import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disbursenav',
  templateUrl: './disbursenav.component.html',
  styleUrls: ['./disbursenav.component.css']
})
export class DisbursenavComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
